module.exports = __webpack_public_path__ + "static/media/29BDOS15.9f747cb8.jpg";